import { useDropdownContext } from '@app/components/various/Dropdown/context/DropdownContext';
import { ChevronDown } from '@app/components/various/Icons';
import { Skeleton } from '@app/components/various/Skeleton';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { getIsLoggedIn } from '@app/ducks';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { useAvailableOrderDetails } from '@app/utils/hooks/useAvailableOrderDetails';
import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

export const OrderSelectTrigger = React.forwardRef<HTMLButtonElement, React.ComponentProps<'button'>>((props, ref) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { buyerFirstName, buyerLastName, accountName, orderName, orderNumber, hasAnyOrderData } = useAvailableOrderDetails();
  const { isDropdownOpen } = useDropdownContext();
  const { trackEvent } = useAmplitude();

  const handleClick = () => {
    trackEvent({ name: 'bottomBar.select.selection.click' });
  };

  return (
    <button
      ref={ref}
      disabled={!isLoggedIn || !hasAnyOrderData}
      type="button"
      className="flex items-center gap-2 overflow-hidden rounded-small text-start disabled:cursor-not-allowed"
      onClick={handleClick}
      {...props}
    >
      <span className={cx('flex flex-col items-start overflow-hidden', { 'gap-0.5': !hasAnyOrderData })}>
        <SkeletonLayout skeleton={<Skeleton type="text" itemClassName="w-40" />} isLoading={!hasAnyOrderData}>
          <span data-sentry-mask className="w-full truncate text-neutral-60 heading-4">
            {buyerFirstName} {buyerLastName} ({accountName})
          </span>
        </SkeletonLayout>
        <SkeletonLayout skeleton={<Skeleton type="text" itemClassName="w-24" />} isLoading={!hasAnyOrderData}>
          <span className="w-full truncate body-1">
            #{orderNumber} {orderName}
          </span>
        </SkeletonLayout>
      </span>
      {isLoggedIn && <ChevronDown className={cx('h-5 w-5 shrink-0 transition-transform', { 'rotate-180': isDropdownOpen })} />}
    </button>
  );
});
